import FormActions from '~/form-actions.vue'

export default {
    components: {
        FormActions
    },
    props     : {
        modelId: {
            type   : Number,
            default: null
        },
        value  : {
            type   : Boolean,
            default: false
        },
    },
    data() {
        return {
            url        : this.$getUrl('warehouses', this.value, this.modelId),
            axiosMethod: this.$getAxiosMethod(this.value, this.modelId),
            forms      : this.$root.$data.forms,
            warehouses : [],
            loading    : false,
        }
    },
    beforeCreate() {
        this.$root.$data.forms.fieldReset();
    },

    watch  : {
        '$route.fullPath'(val) {
            //reset data
            this.forms.reset();
            this.warehouses = []
        }
    },
    created() {
        if(this.axiosMethod === 'patch' || this.modelId)
            this.getData()
    },
    methods: {
        getData() {
            this.loading = true
            this.$root.$data.erp.request.get(this.url, this, (data) => {
                this.warehouses       = data.warehouses
                this.forms.id         = this.warehouses.id
                this.forms.code       = this.warehouses.code
                this.forms.type       = this.warehouses.type
                this.forms.email      = this.warehouses.email
                this.forms.name       = this.warehouses.name
                this.forms.phone      = this.warehouses.phone
                this.forms.address    = this.warehouses.address
                this.forms.is_default = this.warehouses.is_default
                this.loading          = false
            })
        },
        postWarehouse($e) {
            let submitter = $e.submitter.value
            // return null
            this.loading  = true
            this.forms.submit(
                this.axiosMethod,
                this.$getUrlForm(this.url),
                true,
                this.$root)
                .then(data => {
                    this.loading = false
                    if(this.value) {
                        if(submitter === 'submit-close' || submitter === 'update-close') {
                            this.$emit('input', false)
                        }
                    }
                    this.$axiosPostDialog(data)
                }).catch(error => {
                this.loading = false
            });
        },

        onCancel() {
            this.forms.reset();
        }
    }
}